import React, { useEffect, useState } from 'react';
import { Typography, Box, Grid, Button, TextField, Pagination, Switch, FormGroup, FormControlLabel, CircularProgress, Dialog, DialogContent, DialogActions, DialogTitle, Snackbar, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { green } from '@mui/material/colors';
import MuiAlert from '@mui/material/Alert';
import TableInfo from '../../components/TableInfo';
import { useEvent } from '../../contexts/event.context'
import Add from '@mui/icons-material/Add';

import * as yup from 'yup';
import { useFormik } from 'formik';

import api, { baseURL } from '../../services/api';
import { use } from 'react';

export default function EventPresentations() {
    const [loadingFile, setLoadingFile] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [listFiles, setListFiles] = useState([]);
    const [sendingDocument, setSendingDocument] = useState(false);
    const [stateAlert, setStateAlert] = useState({ status: false, type: 'success', msg: '' });
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const { events, getEvents } = useEvent();
    const [selectedEvent, setSelectedEvent] = useState('');
    const [nameEvent, setNameEvent] = useState();
    const [editFile, setEditFile] = useState();
    const pageSize = 50;
    const columns = [
        { Header: "Arquivo", accessor: "title", width: "100%" },
        { Header: "Status", accessor: "status", with: "100%" },
        { Header: "Ações", accessor: "actions", width: "100%" },
    ];

    const validationDocument = yup.object({
        title: yup
            .string('Insira o nome do Arquivo')
            .required('Campo necessário'),
        status: yup
            .boolean(),
        event: yup
            .string()
            .required('Evento não selecionado para inclusão de material'),
        file: yup
            .mixed()
            .test('fileOrLink', 'Envie um arquivo ou preencha o link', function (value) {
                const { link } = this.parent;
                return !!value || !!link;
            }),
        link: yup
            .string()
            .nullable()
            .url('Insira um link válido')
            .test('fileOrLink', 'Envie um arquivo ou preencha o link', function (value) {
                const { file } = this.parent;
                return !!value || !!file;
            }),
    });

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });
    useEffect(() => {
        getEvents(1,50,true);
    }, [])

    async function handleCertificate(event) {
        const files = event.target.files;
        const formData = new FormData();
        formData.append('files', files[0]);
        setLoadingFile(true);
        try {
            const doc = await api.post('/upload', formData);
            formDocument.setFieldValue(event.target.name, doc.data[0].id);
            setStateAlert({ status: true, type: 'success', msg: `${event.target.name} enviado com sucesso` });
            setLoadingFile(false);
        } catch (error) {
            setStateAlert({ status: true, type: 'error', msg: 'Erro ao enviar!' });
            setLoadingFile(false);
        }
    }

    const formDocument = useFormik({
        initialValues: { title: '', status: true, file: null, link: null, event: null },
        validateOnMount: true,
        validationSchema: validationDocument,
        enableReinitialize: true,
        onSubmit: (values) => {
            sendData(values);
        },
    });

    async function sendData(values) {
        if (!selectedEvent) {
            setStateAlert({ status: true, type: 'error', msg: 'Selecione um evento' });
            return;
        }
        try {
            setSendingDocument(true);
            const documentSaved = await api.post('/materials', { data: { ...values, event: selectedEvent } });
            if (documentSaved.status === 200) {
                setStateAlert({ status: true, type: 'success', msg: 'Material salvo com sucesso' });
                setSendingDocument(false);
                await handleFiles(selectedEvent);
                formDocument.handleReset();
                setDialogOpen(false);
            }
        } catch (error) {
            setStateAlert({ status: true, type: 'error', msg: `${error.message}` });
            setSendingDocument(false);
        }
    }

    async function handleDelete(id) {
        try {
            const file = listFiles.find(file => id == file.id)
            const fileUpload = file.attributes.file.data ? file.attributes.file.data[0].id : null
            console.log(fileUpload)
            const deleteFile = await api.delete('/materials/' + id);
            if (deleteFile.status === 200) {
                setStateAlert({ status: true, type: 'success', msg: `Material excluído com sucesso` });
                if (fileUpload) await api.delete('/upload/files/' + fileUpload)
                await handleFiles(selectedEvent);
            }
        } catch (error) {
            setStateAlert({ status: true, type: 'error', msg: `${error.message}` });
        }
    }

    async function handleView({ id }) {
        try {
            const link = listFiles.find(file => id == file.id)?.attributes?.link;
            if (link) {
                window.open(link, '_blank');
                return;
            }
            const [files] = listFiles.filter(file => id == file.id);
            if (files.attributes?.file?.data[0]?.attributes?.url !== null) {
                window.open(`${baseURL + files.attributes.file.data[0].attributes.url}`, '_blank');
            }
        } catch (error) {
            setStateAlert({ status: true, type: 'error', msg: `${error.message}` });
        }
    }
    async function handleEdit(id) {
        try {
            if (!id) return;
            const file = listFiles.find(file => id == file.id)
            if (file) {
                console.log(file,file.attributes.file.data[0].id )
                setEditFile(file)
                formDocument.setFieldValue('title', file.attributes.title);
                formDocument.setFieldValue('event', selectedEvent);
                formDocument.setFieldValue('status', file.attributes.status);
                formDocument.setFieldValue('link', file.attributes.link || null);
                formDocument.setFieldValue('file', file.attributes.file?.data[0]?.id || null);
                setDialogOpen(true)
            }
        } catch (error) {
            console.log(error)
            alert(error)
        }

    }
    async function handleUpdate() {
        const { title, status, link, file } = formDocument.values
        console.log(title, status, link, file)
        console.log(editFile.id)
        try {
            const updateMaterial = await api.put('/materials/' + editFile.id, {
                data: {
                    title,
                    status,
                    link,
                    file
                }
            })
            if (updateMaterial.status == 200) {
                setDialogOpen(false)
                formDocument.handleReset();
                handleFiles(selectedEvent);
                setEditFile(null)
            }
        } catch (error) {
            console.log(error)
            alert(error)
        }

    }

    async function handleFiles(eventId, pageNumber = 1) {
        if (!eventId) return;
        setLoading(true);
        try {
            const files = await api.get(`/materials?populate=*&filters[event]=${eventId}&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}`);
            if (files.status === 200) {
                setListFiles(files.data.data);
                setPage(files.data.meta.pagination.page);
                setPageCount(files.data.meta.pagination.pageCount);
                setLoading(false);
            }
        } catch (error) {
            setStateAlert({ status: true, type: 'error', msg: `${error.message}` });
            setLoading(false);
        }
    }


    return (
        <Box sx={{ width: '100%', height: '100vh' }} p={5}>
            <Grid container spacing={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Grid item xs={12} md={4}>
                    <Typography variant='h4'>Materiais e Apresentações</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                        <InputLabel id="event-select-label">Evento</InputLabel>
                        <Select
                            labelId="event-select-label"
                            id="event-select"
                            value={selectedEvent}
                            label="Evento"
                            onChange={e => {
                                setSelectedEvent(e.target.value)
                                handleFiles(e.target.value)
                                formDocument.setFieldValue('event', e.target.value)
                                setNameEvent(events.filter(ev => e.target.value == ev.id)[0].attributes.name)
                            }}
                        >
                            {events.map(ev => (
                                <MenuItem key={ev.id} value={ev.id}>{ev.attributes?.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" disabled={!selectedEvent} onClick={() => {
                        formDocument.handleReset()
                        formDocument.setFieldValue('event', selectedEvent);
                        setEditFile(null)
                        setDialogOpen(true)

                    }} startIcon={<Add />}>Adicionar Material</Button>
                </Grid>
            </Grid>
            <Snackbar
                open={stateAlert.status}
                autoHideDuration={2500}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={() => setStateAlert({ status: false, type: 'success', msg: '' })} >
                <Alert sx={{ width: '100%' }} severity={`${stateAlert.type}`}>
                    {stateAlert.msg}
                </Alert>
            </Snackbar>
            <Dialog
                open={dialogOpen}
                maxWidth={'lg'}
                aria-describedby="edit-dialog" >
                <DialogTitle>{`Adicionar Material/Apresentação para Evento ${nameEvent}`}</DialogTitle>
                <form onSubmit={formDocument.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2} columns={12} sx={{ justifyContent: 'center' }}>
                            <Grid item xs={10}>
                                <TextField sx={{ width: '100%' }}
                                    label="Título do material"
                                    id='title'
                                    name="title"
                                    variant="outlined"
                                    value={formDocument.values.title}
                                    onChange={formDocument.handleChange}
                                    error={formDocument.touched.title && Boolean(formDocument.errors.title)}
                                    helperText={formDocument.touched.title && formDocument.errors.title}
                                    placeholder="Título do material"
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormGroup>
                                    <FormControlLabel
                                        name="status"
                                        control={<Switch defaultChecked={formDocument.values.status} />}
                                        id="status"
                                        onChange={formDocument.handleChange}
                                        error={formDocument.values.status && Boolean(formDocument.values.status)}
                                        helperText={formDocument.values.status && formDocument.values.status}
                                        value={formDocument.values.status}
                                        label={"Status da Publicação"} />
                                </FormGroup>
                            </Grid>
                            <Grid item xs={10}>
                                <Box sx={{ m: 1, position: 'relative' }}>
                                    <Button variant="contained" component="label" fullWidth disabled={loadingFile} >
                                        Adicionar Arquivo
                                        <input
                                            hidden
                                            name="file"
                                            type={'file'}
                                            accept={".png, .jpg, .jpeg, .pdf, .docx, .doc, .xlsx, .xls, .ppt, .pptx, .csv, .txt, .zip, .rar, .mp4, .avi, .mov, .mkv, .svg, .webp, .gif, .bmp, .tiff, .odt, .ods, .odp, .rtf, .html, .xml, .json, .md"}
                                            label="Adicionar Arquivo"
                                            onChange={(e) => handleCertificate(e)}
                                            error={formDocument.touched.file && Boolean(formDocument.errors.file)}
                                            helperText={formDocument.touched.file && formDocument.errors.file}
                                            sx={{ width: '100%' }}
                                            variant="outlined"
                                        />
                                    </Button>
                                    {loadingFile && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[500],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>
                                <Typography variant='caption'>{!!formDocument.values.file ? 'Documento Enviado' : ''}</Typography>
                                <Typography variant='caption' color={"#FF0000"}>{formDocument.errors.file}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    sx={{ width: '100%' }}
                                    label="Link do material (opcional)"
                                    id="link"
                                    name="link"
                                    variant="outlined"
                                    value={formDocument.values.link}
                                    onChange={formDocument.handleChange}
                                    error={formDocument.touched.link && Boolean(formDocument.errors.link)}
                                    helperText={formDocument.touched.link && formDocument.errors.link}
                                    placeholder="https://exemplo.com/material.pdf"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='outlined' onClick={() => { setDialogOpen(false); formDocument.handleReset(); }} color="error">Cancelar</Button>
                        <Box sx={{ m: 1, position: 'relative' }}>
                            {editFile ? <Button variant="contained" color='success' onClick={handleUpdate} fullWidth disabled={sendingDocument}>Atualizar</Button>
                                :
                                <Button variant="contained" color='success' onClick={() => {
                                    console.log(formDocument.status)
                                    formDocument.handleSubmit()
                                }
                                } fullWidth disabled={sendingDocument}>Salvar</Button>}
                            {sendingDocument && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                    </DialogActions>
                </form>
            </Dialog>
            <Grid container p={3}>
                {loading ?
                    <Box sx={{ width: '100%', height: '10vh', display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress sx={{ alignSelf: 'center' }} size={50} />
                    </Box>
                    :
                    <>
                        <TableInfo title='Materiais/Apresentações' variant="secondary" deactive={handleDelete} edit={handleEdit} list={handleView} rows={listFiles} columns={columns} />
                        <Grid container justifyContent="center" sx={{ mt: 2 }}>
                            <Pagination
                                count={pageCount}
                                page={page}
                                onChange={(e, value) => {
                                    setPage(value);
                                    handleFiles(selectedEvent, value);
                                }}
                                color="primary"
                            />
                        </Grid>
                    </>
                }
            </Grid>
        </Box>
    );
}
